// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"271":"0c7de36c","928":"1ac17eab"}[chunkId] + ".chunk.css";
};